import React from 'react';
import styled from 'styled-components';
import { Translate } from 'hooks/use-translation';

const ContentItems = styled.ul`
  padding: var(--spacing-05);
`;

const ConfirmationContentWrapper = styled.div`
  ${ContentItems} {
    margin-bottom: var(--spacing-05);
  }
`;

export const removalConfirmationContent = (
  memberName: string,
  projectName: string,
  translate: Translate,
): JSX.Element => {
  const messageContentHeader = translate(
    'resource_management.actions.remove_member.confirmation.message.starter',
    { memberName, projectName, strong: (chunks) => <strong>{chunks}</strong> },
  );
  const messageContentListItems = [
    translate(
      'resource_management.actions.remove_member.confirmation.message.1',
      { memberName },
    ),
    translate(
      'resource_management.actions.remove_member.confirmation.message.2',
      { memberName },
    ),
  ];
  const messageContentConfirmation = translate(
    'resource_management.actions.remove_member.confirmation.message.finisher',
  );

  return (
    <ConfirmationContentWrapper>
      <span>{messageContentHeader}</span>
      <ContentItems>
        {messageContentListItems.map((item) => (
          <li>{item}</li>
        ))}
      </ContentItems>
      <span>{messageContentConfirmation}</span>
    </ConfirmationContentWrapper>
  );
};
